<template>
<v-container fluid pa-0>
  <v-card>
  <v-alert :value="true" type="success" dismissible v-model="alertSuccess">
      {{ resultMessage }}
  </v-alert>
  <v-alert :value="true" type="error" dismissible v-model="alertError">
      {{ resultMessage }}
  </v-alert>
  <v-toolbar class="elevation-1">
  <v-toolbar-title>  
    Students
  </v-toolbar-title>
        <v-spacer></v-spacer>
            <v-text-field
          append-icon="search"
          label="Search"
          flat
          v-model="search"
          solo
        ></v-text-field>
    </v-toolbar>
    <v-data-table
        :headers="headers"
        :items="items"
        item-key="id"
        :pagination.sync="pagination"
        :total-items="totalItems"
        :loading="loading"
        :rows-per-page-items="rowsPerPageItems"
        class="elevation-1">
          <template slot="items" slot-scope="props">
            <td>{{ props.item.lastName }}</td>
            <td>{{ props.item.firstName }}</td>        
            <td>{{ props.item.email }}</td>
            <td>{{ props.item.cohort }}</td>
            <td>
              <v-btn slot="activator" flat small color="primary" ref="icon"
                  :to="{ name: 'StudentEfforts', params: { studentId: props.item.id }}"
              ><v-icon dark>assignment_turned_in</v-icon> Effort grades
              </v-btn>
              <v-tooltip bottom>
                <v-btn slot="activator" fab :dark="!isTeacher" small color="primary" outline ref="icon"
                    :to="{ name: 'MyEffortsStudent', params: { studentId: props.item.id, student: props.item }}"
                ><v-icon dark>assignment</v-icon>
                </v-btn>
                <span>Grade Summary</span>
              </v-tooltip>
              <v-tooltip bottom>
                <v-btn slot="activator" fab dark small color="primary" outline ref="icon"
                    :to="{ name: 'StudentDashboard', params: { studentId: props.item.id, student: props.item }}"
                ><v-icon dark>dashboard</v-icon>
                </v-btn>
                <span>Dashboard</span>
              </v-tooltip>
              <v-tooltip bottom>
                <v-btn slot="activator" fab dark small color="primary" outline ref="icon" 
                    :to="{ name: 'StudentMotionChart', params: { studentId: props.item.id, student: props.item }}"
                ><v-icon dark >bubble_chart</v-icon>
                </v-btn>
                <span>Bubble Chart</span>
              </v-tooltip>
              <v-tooltip bottom v-show="!isTeacher">
                <v-btn slot="activator" fab small color="red" outline 
                  @click.stop="loadDialog(props.item.email)"
                  v-bind:value="props.item.id"
                ><v-icon dark>password</v-icon>
                </v-btn>
                <span>Reset Password</span>
              </v-tooltip>
            </td>
          </template>
    </v-data-table>
    <v-dialog v-model="dialog" max-width="35%">
      <v-card>
          <v-card-title>
              Confirmation
          </v-card-title>
          <v-card-text>
              <v-layout row wrap>
                 <v-layout row wrap>
                        This action will &nbsp; <span style="color: #b71c1c !important;"><b> RESET </b></span> &nbsp; the Student password. User: &nbsp;  
                        <b> {{ selectedStudentEmail }}  &nbsp; </b> 
                  </v-layout>
              </v-layout>
          </v-card-text>
          <v-card-text>
              <v-layout row wrap>
                 <v-layout row wrap>
                        <i>The new password will be the default school password for students. If you want to set a specific password, please type it here:</i>
                  </v-layout>
                  <v-layout row wrap>
                          <v-text-field
                            :append-icon="studentsDefaultPasswordMask ? 'visibility' : 'visibility_off'"
                            @click:append="() => (studentsDefaultPasswordMask = !studentsDefaultPasswordMask)"
                            :type="studentsDefaultPasswordMask ? 'password' : 'text'"
                            label="New password"
                            hint="At least 6 characters"
                            min="8"
                            v-model="txtNewPassword" 
                            >
                            <v-tooltip slot="append-outer" right> 
                                    <v-icon slot="activator" @click="generatePassword()">password</v-icon>
                                <span>suggest strong password</span>
                            </v-tooltip>
                        </v-text-field>
                  </v-layout>
              </v-layout>
          </v-card-text>
          <v-card-actions>
              <v-btn color="primary" flat @click.stop="unloadDialog()">Cancel</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="error" outlined @click.stop="resetPassword()">Confirm</v-btn>
          </v-card-actions>
      </v-card>
    </v-dialog>    
  </v-card>
</v-container>

</template>
<script>
  import { initialize, getPeriods, getListByPeriod, putResetPassword, resetUserPasswordToDefault, getSetting} from '../utils/effort-tracking-api';
  import { globalStore } from '../main'

  export default {
    data () {
      return {
        search: '',
        totalItems: 0,
        loading: false,
        rowsPerPageItems: globalStore.rowsPerPageItems ,
        pagination: { sortBy: 'lastName', rowsPerPage: globalStore.defaultRowsPerPage },
        headers: [
          { text: 'Last Name', value: 'lastName' },
          { text: 'First Name', value: 'firstName' },          
          { text: 'Email', value: 'email' },
          { text: 'Cohort', value: 'cohort' },
          { text: '', value: '', sortable: false }
        ],
        items: [],
        isTeacher: false,
        alertSuccess: false,
        alertError: false,
        dialog: false,
        selectedStudentEmail: '',
        resultMessage: '',
        defaultPassword: '',
        txtNewPassword: '',
        settings: {
                    maxLength: 64,
                    maxDigits: 10,
                    maxSymbols: 10,
                    length: 12,
                    digits: 4,
                    symbols: 2,
                    ambiguous: true,
                },
        studentsDefaultPasswordMask: true
      }
    },
    watch: {
      search: {
        handler () {
           this.debouncedGetDataFromApi()
        },
      },
      pagination: {
        handler () {
            this.debouncedGetDataFromApi()
        },
        deep: true
      }
    },
    mounted () {
      this.isTeacher = this.$store.state.usertype == 'teacher' || this.$store.state.usertype == 'middlemanager';
      this.debouncedGetDataFromApi = _.debounce(this.getDataFromApi, 500, { trailing:true })
      
      initialize().then(x => {
        getSetting('students-default-password').then(setting => {
            this.txtNewPassword = (setting.value !== undefined ) ? setting.value : 'effort23';
            this.defaultPassword = this.txtNewPassword;
        }).catch(ex => console.log(ex));
        
        getPeriods().then(periods => {
          console.log('periods');
          console.log(periods);
          this.$store.state.periods = periods;
          console.log('store state periods');
          console.log(this.$store.state.periods);

        }).catch(ex => console.log(ex));
      }).catch(ex => console.log(ex));
    },
    methods: {
      changeSort (column) {
        if (this.pagination.sortBy === column) {
          this.pagination.descending = !this.pagination.descending
        } else {
          this.pagination.sortBy = column
          this.pagination.descending = false
        }
      },
      getDataFromApi () {
        this.loading = true;
        getListByPeriod("students", this.pagination, this.search).then(data => {
          this.items = data.items
          this.totalItems = data.count
          this.loading = false;
        })
      },
      unloadDialog() {
        this.dialog = false;
        this.selectedStudentEmail = '';
      },
      loadDialog(studentEmail) {
        this.alertSuccess = false;
        this.alertError = false;
        this.dialog = true;
        this.selectedStudentEmail = studentEmail;
      },
      resetPassword() {

        console.log(this.txtNewPassword);

        if (this.txtNewPassword != "")
        {
          putResetPassword({user: this.selectedStudentEmail, newPassword: this.txtNewPassword}).then(result => {
            this.dialog = false;
            this.selectedTeacherEmail = '';
            if(result.status == 200) {
              this.resultMessage = result.data;
              this.alertSuccess = true;
              this.txtNewPassword = this.defaultPassword;
              this.studentsDefaultPasswordMask = true;
            } else {
              this.resultMessage = result.response.data;
              this.alertError = true;
              this.txtNewPassword = this.defaultPassword;
              this.studentsDefaultPasswordMask = true;
            }
          });
        }
        else
        {
          resetUserPasswordToDefault("Students",this.selectedStudentEmail).then(result => {
            this.dialog = false;
            this.selectedStudentEmail = '';
            if(result.status == 200) {
              this.resultMessage = result.data;
              this.alertSuccess = true;
            } else {
              this.resultMessage = result.response.data;
              this.alertError = true;
            }
          });
        }
      },
      // generate the password
      generatePassword() {
          var lettersSetArray = ["a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z"];
          var symbolsSetArray = [ "=","+","-","^","?","!","%","&","*","$","#","^","@","|"];
          //var ambiguousSetArray = ["(",")","{","}","[","]","(",")","/","~",";",":",".","<",">"];
          var passwordArray = [];
          var digitsArray = [];
          var digitsPositionArray = [];


          // first, fill the password array with letters, uppercase and lowecase
          for (var i = 0; i < this.settings.length; i++) {
              // get an array for all indexes of the password array
              digitsPositionArray.push(i);

              var upperCase = Math.round(Math.random() * 1);
              if (upperCase === 0) {
              passwordArray[i] = lettersSetArray[Math.floor(Math.random()*lettersSetArray.length)].toUpperCase();
              }
              else {
              passwordArray[i] = lettersSetArray[Math.floor(Math.random()*lettersSetArray.length)];
              }
          }

          // Add digits to password
          for (i = 0; i < this.settings.digits; i++) {
              var digit = Math.round(Math.random() * 9);
              var numberIndex = digitsPositionArray[Math.floor(Math.random()*digitsPositionArray.length)];

              passwordArray[numberIndex] =  digit;

              /* remove position from digitsPositionArray so we make sure to the have the exact number of digits in our password
              since without this step, numbers may override other numbers */

              var j = digitsPositionArray.indexOf(numberIndex);
              if(i != -1) {
              digitsPositionArray.splice(j, 1);
              }
          }

          // add special charachters "symbols"
          for (i = 0; i < this.settings.symbols; i++) {
              var symbol = symbolsSetArray[Math.floor(Math.random()*symbolsSetArray.length)];
              var symbolIndex = digitsPositionArray[Math.floor(Math.random()*digitsPositionArray.length)];

              passwordArray[symbolIndex] =  symbol;

              /* remove position from digitsPositionArray so we make sure to the have the exact number of digits in our password
              since without this step, numbers may override other numbers */

              var j = digitsPositionArray.indexOf(symbolIndex);
              if(i != -1) {
              digitsPositionArray.splice(j, 1);
              }
          }

          this.txtNewPassword = passwordArray.join("");
          this.studentsDefaultPasswordMask = false;
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Students.vue